<template>
	<div class="d-flex flex-column ">
		<!-- -->
	<BaseHead :hide="TheaderHide" class="d-print-none" />
	<main class="page-wrapper flex-grow-1 flex-fill" >
		<!-- :style="{ height: `calc(100dvh - ${TheaderHide? 41 : 0 }px - 22px )` }" -->
	<!-- ,marginBottom:!printPage?0:`25px` -->
		<slot />
	</main>
	<BaseFooter v-if="printPage" class="d-print-none"/>
	</div>
	<!-- Modal with tabs and forms -->
</template>
<script setup lang="ts">
	import usePub from "~/store/Public";
	const headerHide = ref(useRoute().query.headerHide ? useRoute().query.headerHide?.toString() == "1" : true);
	const printPage = ref(!useRoute().query?.print);
	usePub().isHeader = headerHide.value;
	const TheaderHide = computed({
		get() {
			return usePub().isHeader && headerHide.value;
		},
		set() {},
	});
</script>
